import * as React from 'react';
import './App.css';
import { Route } from 'react-router';
import CurrentEstimations from './view/estimations/Estimations';
import NavBar from './view/navbar/NavBar';
import protect from './view/protect';
import { ConnectedRouter } from 'connected-react-router';
import { history } from './application/core/createStore';
import Admin from './view/admin/Admin';
import ChangePassword from './view/login/ChangePassword';
import Clients from './view/admin/Clients';
import AdminEstimations from './view/admin/Estimations';
import UserOrders from './view/order/UserOrders';
import UserEstimations from './view/estimations/UserEstimations';
import Dashboard from './view/account/Dashboard';
import Login from './view/login/Login';
import Logout from './view/Logout';
import ForgotPassword from './view/login/ForgotPassword';
import Notifications from './view/notifications/Notifications';
import ApplicationInitialized from './application/core/events/ApplicationInitialized';
import DispatchProps, { mapDispatchToProps } from './application/core/DispatchProps';
import { connect } from 'react-redux';
import Popup from './view/popup/Popup';
import ClientDetails from './view/admin/ClientDetails';
import MyAccount from './view/account/MyAccount';
import User from './application/user/State';
import State from './application/core/State';
import Role from './domain/Role';
import Order from './view/order/details/Order';
import CurrentOrder from './view/order/Order';
import CustomerEstimation from './view/estimations/details/CustomerEstimation';
import CustomerOrder from './view/order/details/CustomerOrder';
import Estimations from './view/estimations/details/Estimation';
import IntegrationPanel from './view/admin/integration/IntegrationPanel';
import Features from './view/admin/Features';
import AppLoader from './view/common/AppLoader';

interface StateProps {
    userInformation: User;
}

class App extends React.PureComponent<DispatchProps & StateProps> {
    public componentDidMount(): void {
        this.props.dispatch(new ApplicationInitialized());
    }
    public render(): JSX.Element {
        return (
            <div className="App">
                <ConnectedRouter history={history}>
                    <div>
                        <Features />
                        <Popup />
                        <AppLoader />
                        <NavBar />
                        <Notifications />
                        <Route path="/order" component={protect(CurrentOrder)} exact={true} />
                        <Route path="/orders-history" component={protect(UserOrders)} />
                        <Route path="/orders/:orderId" component={protect(Order)} exact={true} />
                        <Route path="/estimations" component={protect(CurrentEstimations)} exact={true} />
                        <Route path="/estimations-history" component={protect(UserEstimations)} />
                        <Route path="/estimations/:estimationId" component={protect(Estimations)} exact={true} />
                        <Route exact={true} path="/admin" component={protect(Admin)} />
                        <Route path="/account" component={protect(MyAccount)} />
                        {this.props.userInformation.role === Role.Admin ? (
                            <Route path="/" exact={true} component={protect(Dashboard)} />
                        ) : (
                            <Route path="/" exact={true} component={protect(MyAccount)} />
                        )}
                        <Route path="/admin/customers/:customerId/orders/:orderId" component={protect(CustomerOrder)} exact={true} />
                        <Route
                            path="/admin/customers/:customerId/estimations/:estimationId"
                            component={protect(CustomerEstimation)}
                            exact={true}
                        />
                        <Route path="/admin/customers/:customerId" component={protect(ClientDetails)} exact={true} />
                        <Route path="/admin/customers" component={protect(Clients)} exact={true} />
                        <Route path="/admin/estimation-periods" component={protect(AdminEstimations)} />
                        <Route path="/admin/integration-panel" component={protect(IntegrationPanel)} />
                        <Route path="/login" component={Login} />
                        <Route path="/logout" component={Logout} />
                        <Route path="/change-password" component={ChangePassword} />
                        <Route path="/forgot-password" component={ForgotPassword} />
                    </div>
                </ConnectedRouter>
            </div>
        );
    }
}

const mapStateToProps = (state: State): StateProps => ({
    userInformation: state.user
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.tsx